import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { useSelector } from 'react-redux';
import Header from '../../../Header/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { InWardDBValidation } from '../../../CommonUtils/Validations/Validations';

export default function InwardDashboard() {
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const location = useLocation()
    let navigate = useNavigate()
    const data2 = location?.state
    const [showList, setList] = useState(data2?.data?.list);
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            entry_by: loginreducer?.username,
            inward_date_from:"",
            inward_date_upto:"",

        },
        onSubmit: (values) => {
            GetChequeInReport(values);
        },
        validationSchema: InWardDBValidation
    })
    function GetChequeInReport(values) {
        let url = config.url.BOC_URL + "inward-dashboard";
        CommonAxiosPost(url, values).then((res) => {
            if (res?.data?.status === true) {
                setList(res?.data?.inward_dashboard)
            }
        }
        )
    } useEffect(() => {
       if(data2?.data?.todate){
        Formik.setFieldValue("inward_date_from",data2?.data?.fromDate)
        Formik.setFieldValue("inward_date_upto",data2?.data?.todate)
       }

    }, [])

   
   
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Inward Dashboard" path="/Dashboard" />
            <jnb.Container className="outer-page-content-container" >
                <FormikProvider value={Formik}>
                    <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                        <jnb.Row className="pt-0 mt-2">
                            {/* <div className="inner-herbpage-service-title-sub">
                            <h1>Work Details</h1>
                        </div> */}
                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                <jnb.InputGroup className="">
                                    <label>From Date</label>
                                </jnb.InputGroup>
                                <Field type="date" className="form-control" name="inward_date_from" />
                                <ErrorMessage name="inward_date_from" component="div" className="text-error" />
                            </jnb.Col>
                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                <jnb.InputGroup className="">
                                    <label>To Date</label>
                                </jnb.InputGroup>
                                <Field type="date" className="form-control" name="inward_date_upto" />
                                <ErrorMessage name="inward_date_upto" component="div" className="text-error" />
                            </jnb.Col>
                            <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className="mb-1">
                                <button type="submit" className="btn btn-primary btn-sm mt-4">Get Data</button>
                            </jnb.Col>
                        </jnb.Row>

                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                                <thead>
                                    <tr>
                                        <th rowSpan={3}>S.NO</th>
                                        <th rowSpan={3}>Cfms Id</th>
                                        <th colSpan={2}>Total Bank Sent</th>
                                        <th colSpan={6}>Payment Status</th>

                                    </tr>
                                    <tr>
                                        <th rowSpan={2}>Count</th>
                                        <th rowSpan={2}>Amount</th>
                                        <th colSpan={2}>Success</th>
                                        <th colSpan={2}>Failure</th>
                                        <th colSpan={2}>Pending</th>

                                    </tr>
                                    <tr>

                                        <th>count</th>
                                        <th>Amount</th>
                                        <th>count</th>
                                        <th>Amount</th>
                                        <th>count</th>
                                        <th>Amount</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {showList?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item?.incharge_cfms_id}</td>
                                            <td>{item?.tot_count}</td>
                                            <td>{item?.tot_amount}</td>
                                            <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}
                                                onClick={() => {
                                                    navigate("/InwardDaywiseDashboard", { state: { data: item, fromDate: Formik?.values?.inward_date_from, todate: Formik?.values?.inward_date_upto, status: "S", list: showList } })

                                                }}>{item?.success_count}</td>
                                            <td>{item?.success_amount}</td>
                                            <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}
                                                onClick={() => {
                                                    navigate("/InwardDaywiseDashboard", { state: { data: item, fromDate: Formik?.values?.inward_date_from, todate: Formik?.values?.inward_date_upto, status: "F" , list: showList} })

                                                }}>{item?.fail_count}</td>
                                            <td>{item?.fail_amount}</td>
                                            <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}
                                                onClick={() => {
                                                    navigate("/InwardDaywiseDashboard", { state: { data: item, fromDate: Formik?.values?.inward_date_from, todate: Formik?.values?.inward_date_upto, status: "P", list: showList } })

                                                }}>{item?.pending_count}</td>
                                            <td>{item?.pending_amount}</td>
                                            {/* <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}
                                                onClick={() => {
                                                    navigate("/InwardDaywiseDashboard", { state: { data: item ,fromDate:Formik?.values?.inward_date_from , todate: Formik?.values?.inward_date_upto} })

                                                }}>{item?.days}</td> */}


                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>

                                        <td colSpan={2} className='text-right'>Total</td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.tot_count),
                                                0
                                            )}
                                        </td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.tot_amount),
                                                0
                                            )}
                                        </td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.success_count),
                                                0
                                            )}
                                        </td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.success_amount),
                                                0
                                            )}
                                        </td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.fail_count),
                                                0
                                            )}
                                        </td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.fail_amount),
                                                0
                                            )}
                                        </td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.pending_count),
                                                0
                                            )}
                                        </td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.pending_amount),
                                                0
                                            )}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </jnb.Form>
                </FormikProvider>
            </jnb.Container>




        </React.Fragment>
    )
}
